const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/_about/about/providers.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_pages/$lang/_about/about/providers.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { alternatesToLinks, buildLocalizedPageAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_pages/$lang/_about/about/providers")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "home"
    });
    const alts = buildLocalizedPageAlternates(locale, "about", "providers");
    return {
      meta: await buildPagePreviewMetaTags({
        title: t("providerPageTitle"),
        description: t("providerPageDescription"),
        canonicalUrl: alts.canonical
      }, {
        openGraph: {},
        twitter: {}
      }, {
        locale
      }),
      links: alternatesToLinks(alts)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});